export type FootstepGait = 'walk' | 'run' | 'sprint';
export const FOOTSTEP_WALK_MAX_FT_PER_SECOND = 7.5;
export interface FootContactSample {
  height: number; time: number; velocity: number; minimum: number; lastContact: number; contact: boolean; armed: boolean;
}

/** In-place contact sampler: a 4 cm lift arms one landing near the tracked low. Heights are metres. */
export function sampleFootContact(previous: FootContactSample | null, height: number, time: number): FootContactSample {
  if (!previous) return { height, time, velocity: 0, minimum: height, lastContact: -Infinity, contact: false, armed: false };
  if (time <= previous.time) {
    previous.height = height; previous.time = time; previous.velocity = 0; previous.minimum = height;
    previous.contact = false; previous.armed = false;
    return previous;
  }
  const dt = time - previous.time;
  const velocity = (height - previous.height) / dt;
  const minimum = Math.min(height, previous.minimum + dt * .03);
  const contact = previous.armed && previous.velocity < 0 && velocity >= 0
    && height <= minimum + .03 && time - previous.lastContact >= .18;
  if (contact) { previous.lastContact = time; previous.armed = false; }
  else if (velocity > 0 && height >= minimum + .04) previous.armed = true;
  previous.height = height; previous.time = time; previous.velocity = velocity; previous.minimum = minimum; previous.contact = contact;
  return previous;
}
